module.exports = __webpack_public_path__ + "static/media/logooo.98d72e5b.png";